export const AUTH_COOKIE = 'duibq2edqu2ydjabwbd'
